import React, { useState } from 'react';
import '../WidgetEditTypes/TopWidgetEdit.css';

function LayoutSettingsSection({ layoutConfig, editData, handleInputChange }) {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };
    
    return (
        <div>
            {/* Layout Settings Header mit Toggle */}
            <div 
                className="elegant-input-container clickable-toggle"
                onClick={!isExpanded ? toggleExpanded : undefined}
            >
                <div className="elegant-input-header">
                    <div className="elegant-label-row">
                        <label className="elegant-input-label">Layout Settings</label>
                        <button 
                            type="button"
                            className={`elegant-dots-toggle ${isExpanded ? 'expanded' : ''}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleExpanded();
                            }}
                            title="Layout Settings"
                        >
                            <span className="dot"></span>
                            <span className="dot"></span>
                            <span className="dot"></span>
                        </button>
                    </div>
                    {isExpanded && (
                        <div className="elegant-input-controls expanded">
                            <div className="input-container"> 
                                {layoutConfig.map((layoutItem, index) => (
                                    <div className="input-group" key={index}>
                                        <label htmlFor={layoutItem.fieldName}>{layoutItem.label}:</label>
                                        <input 
                                            id={layoutItem.fieldName}
                                            type="text" 
                                            name={layoutItem.fieldName} 
                                            value={editData[layoutItem.fieldName] || layoutItem.defaultValue}
                                            onChange={handleInputChange} 
                                            className="widgetInputField"
                                        />
                                        {layoutItem.icon && (
                                            <img 
                                                className="label-icon" 
                                                src={layoutItem.icon} 
                                                style={layoutItem.iconStyle || {}} 
                                                alt="" 
                                            />
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default LayoutSettingsSection;
